export function loadFileFromReader(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result);
      }
    };

    reader.onerror = () =>
      reject(new Error('There was an error uploading the file'));
  });
}
